<template>
  <div class="w-full relative">
    <label
      class="block uppercase tracking-wide text-darkGray-1 text-xs font-bold"
      >{{ model.label }}</label
    >
    <div
      :id="'icon-error_' + model.key"
      class="hidden absolute top-[3px] right-0 left-auto w-[20px] flex flex-row justify-center items-center"
      @mouseenter="showErrorMessage"
      @mouseleave="hideErrorMessage"
    >
      <i class="text-red-2 fa-solid fa-circle-info"></i>
    </div>
    <fieldset class="mt-2">
      <div class="space-y-2">
        <InputRadio
          v-for="item in withoutGroup"
          :key="item.item.key"
          :model="item.item"
          :disabled="props.disabled || (adminView && !editMode)"
          :isSelected="item.item.key === selectedKey"
          @change="() => onChange(item.item)"
        />
      </div>
    </fieldset>
    <div v-show="showingErrorMessage" class="relative z-50">
      <div
        class="absolute top-0 left-0 right-0 bottom-auto bg-white rounded-md p-2 shadow-md"
        :id="'outer-error_' + model.key"
      >
        <p
          class="font-medium text-sm text-red-2"
          :id="'error_' + model.key"
        ></p>
      </div>
    </div>
  </div>
</template>
<script setup lang="ts">
import { defineProps, ref, reactive, computed, onMounted } from "vue";
import { defineEmits } from "@vue/runtime-core";
import { DynamicProperty, RadioItem, MetaData } from "@/models/dtos";
import InputRadio from "./InputRadio.vue";
import { useStore } from "vuex";
const emit = defineEmits(["change"]);

const radioButtons = reactive([] as RadioItem[]);
const withoutGroup = computed(() =>
  radioButtons.filter((px) => px.item.type !== "radioGroup")
);

const props = defineProps({
  model: {
    type: DynamicProperty,
    required: true,
  },
  placeholder: String,
  disabled: {
    type: Boolean,
    required: false,
    default: false,
  },
  adminView: {
    type: Boolean,
    required: false,
    default: false,
  },
  editMode: {
    type: Boolean,
    required: false,
    default: false,
  },
});

let model = ref(props.model);

const selectedKey = ref("");

onMounted(() => {
  let properties = (model.value.data.metadata as MetaData).properties.filter(
    (x) => props.model.data.keys.includes(x.key)
  );
  properties.forEach((x) => {
    radioButtons.push(new RadioItem(x, x.label, x.data));
  });

  let selected = radioButtons.find((x) => x.value)?.item?.key;

  if (selected) {
    selectedKey.value = selected;
  }
});

const store = useStore();

function onChange(item: DynamicProperty) {
  selectedKey.value = item.key;
  store.dispatch("selectRadioButton", {
    parentKey: model.value.key,
    keyToSelect: item.key,
    adminView: props.adminView,
  });
}

const showingErrorMessage = ref(false);

const showErrorMessage = () => {
  showingErrorMessage.value = true;
};
const hideErrorMessage = () => {
  showingErrorMessage.value = false;
};
</script>
